import Api from "../../../../service";
import { SET_ADVERTISEMENT, SET_ERROR, getKey } from "./constants";

const setAdvertisement = (data, key) => ({
  type: SET_ADVERTISEMENT,
  data,
  key,
});

const setError = (data, key) => ({
  type: SET_ERROR,
  data,
  key,
});

export const getAdvertisement = (data) => (dispatch) =>
  Api.advertisement
    .getAdvertisement(data)
    .then((response) => {
      dispatch(setAdvertisement(response, getKey(data)));
      return response;
    })
    .catch((error) => {
      console.error(error);
      dispatch(setError(error, getKey(data)));
    });
